import request from '@/utils/request'

let ResumeApi = {

  /*简历列表*/
  list(data) {
    return request._post('/shop/plus.resume.Index/index', data);
},
/*添加简历*/
add(data) {
    return request._post('/shop/plus.resume.Index/add', data);
},

auditResume(data){
    return request._post('/shop/plus.resume.Index/auditResume', data);
},
/*修改简历*/
edit(data) {
    return request._post('/shop/plus.resume.Index/edit', data);
},
/*删除简历*/
del(data) {
    return request._post('/shop/plus.resume.Index/del', data);
},
/*简历详情*/
detail(data) {
  return request._post('/shop/plus.resume.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.resume.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.resume.Setting/getSetting', data, errorback);
    },
}
export default ResumeApi;



// WEBPACK FOOTER //
// ./src/api/resume.js